const StatusValue = Object.freeze({
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Closed: 'CLOSED',
});

export default StatusValue;
